/**
 * Rohstoffkategorien actions.
 * @module actions/Produkt
 */

import {
  GET_ROHSTOFFKATEGORIEN,
  GET_ROHSTOFFKATEGORIEBYID,
  CREATE_ROHSTOFFKATEGORIE,
  UPDATE_ROHSTOFFKATEGORIE,
  DELETE_ROHSTOFFKATEGORIE,
} from '../../constants/ActionTypes';

/**
 * Get Produkt items.
 * @function getProduct
 * @param {string} id Produkt id
 * @returns {Object} Produkt action.
 */
export function getRohstoffkategorien({
  showDeleted = false,
  showAll = false,
  batchingParameters = {},
}) {
  const {
    limit = 10,
    skip = 0,
    sort_by = '',
    asc = false,
    searchTerms = '',
  } = batchingParameters;
  // Initialize an empty array to store query parameters
  const queryParams = [];
  if (sort_by) {
    queryParams.push(`sort_by=${sort_by}`);
  }
  if (searchTerms) {
    queryParams.push(`search=${searchTerms}`);
  }
  // Construct the pathSuffix by joining query parameters with '&'
  let pathSuffix = `?limit=${limit}&skip=${skip}&asc=${asc}`;
  if (queryParams.length > 0) {
    pathSuffix += `&${queryParams.join('&')}`;
  }
  if (showDeleted) {
    return {
      type: GET_ROHSTOFFKATEGORIEN,
      request: {
        op: 'get',
        path: `/@rohstoffkategorien/deleted${pathSuffix}`,
      },
    };
  } else if (showAll) {
    return {
      type: GET_ROHSTOFFKATEGORIEN,
      request: {
        op: 'get',
        path: `/@rohstoffkategorien/all`,
      },
    };
  }

  return {
    type: GET_ROHSTOFFKATEGORIEN,
    request: {
      op: 'get',
      path: `/@rohstoffkategorien${pathSuffix}`,
    },
  };
}

/**
 * Get Benutzer item.
 * @function getBenutzerByID
 * @param {string} id Benutzer id
 * @returns {Object} Benutzer action.
 */
export function getRohstoffkategorieByID(id) {
  return {
    type: GET_ROHSTOFFKATEGORIEBYID,
    request: {
      op: 'get',
      path: `/@rohstoffkategorien/${id}`,
    },
  };
}

/**
 * Create a new Rohstoffkategorie.
 * @function createRohstoffkategorie
 * @param {Object} formData The data of the new Rohstoffkategorie
 * @returns {Object} Rohstoffkategorie action.
 */
export function createRohstoffkategorie(formData) {
  return {
    type: CREATE_ROHSTOFFKATEGORIE,
    request: {
      op: 'post',
      path: '/@rohstoffkategorien',
      data: formData,
    },
  };
}

/**
 * Update a new Rohstoffkategorie.
 * @function createRohstoffkategorie
 * @param {Object} formData The data of the new Rohstoffkategorie
 * @returns {Object} Rohstoffkategorie action.
 */
export function updateRohstoffkategorie(id, formData) {
  return {
    type: UPDATE_ROHSTOFFKATEGORIE,
    request: {
      op: 'patch',
      path: `/@rohstoffkategorien/${id}`,
      data: formData,
    },
  };
}

/**
 * Delete a Rohstoffkategorie.
 * @function createRohstoffkategorie
 * @returns {Object} Success Message;
 */
export function deleteRohstoffkategorie(id) {
  return {
    type: DELETE_ROHSTOFFKATEGORIE,
    request: {
      op: 'del',
      path: `/@rohstoffkategorien/${id}`,
    },
  };
}
